import { Subtitle2 } from '../../../../components/UI/MDC/Typography/Typography';
import styles from './ApplicationForm.module.scss';

/**
 * Text display base component stylized to work with Custom App Request Form
 * @param {Object} props component properties
 * @param {string} props.label display text
 * @param {boolean} props.warning flag to dictate styles for "warning"
 * @param {boolean} props.error  flag to dictate styles for "error"
 * @returns Text display stylized for custom
 */
const AppWrappedLabel = ({ label, warning, error }) => {
	return (
		<Subtitle2
			className={
				warning
					? styles['application-form__label--warning']
					: error
					? styles['application-form__label--invalid']
					: null
			}
		>
			{label}
		</Subtitle2>
	);
};
export default AppWrappedLabel;
